import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ForexTransactionsService {

    constructor(private http: HttpClient) { }

    executeForexTransaction(data: any): Observable<any> {
        const httpParams = new HttpParams();
        return this.http.post(`/exchangerate/exchange`, data, { params: httpParams });
    }

    getLatestExchangeRate(): Observable<any> {
        const httpParams = new HttpParams();
        return this.http.get(`/exchangerate/latest`, { params: httpParams });
    }   
}
